import { useEffect } from "react";
import { useAuth } from "@qure/qure-auth";
import { get, isEmpty } from "lodash";
import { useWorklistSocketStore } from "@/stores/worklist-socket";

/**
 * Establishes the single worklist socket connection for the logged-in user.
 * Call once at the top of the patients-v2 page; disconnects on unmount.
 */
export function useWorklistSocket() {
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var username = get(userInfo, ["username"], "");
  var isLoggedIn = !isEmpty(get(userInfo, ["details"], null));
  var connect = useWorklistSocketStore(function (s) {
    return s.connect;
  });
  var disconnect = useWorklistSocketStore(function (s) {
    return s.disconnect;
  });
  useEffect(function () {
    if (!isLoggedIn || !username) return;
    connect("/worklist/".concat(username, "/"));
    return function () {
      return disconnect();
    };
  }, [isLoggedIn, username, connect, disconnect]);
}